import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { LocaldataService } from '../../service/localdata/localdata.service';


@Component({
  selector: 'app-dueslag',
  templateUrl: './dueslag.page.html',
  styleUrls: ['./dueslag.page.scss']
  
})
export class DueslagPage implements OnInit {

  constructor(private localData: LocaldataService, private router:Router) {

  }

  backToHomepage() {
    this.router.navigate(['/asb/home']);
  }

  ngOnInit() {
    
  }
  ngOnDestroy() {
    
  }

  ionViewDidEnter() {
    this.localData.checkVersionUpdate();
  }


  ionViewWillEnter(){
    this.localData.remoteUpdateFiles();
    this.localData.breadcrumb = [];
  }

}
